import {SymbolGroupApiDto} from "./restModels";

export class SymbolGroup {
	constructor(public readonly id: string, public readonly name: string) {}

	public static fromJson(json: SymbolGroupApiDto): SymbolGroup {
		return new SymbolGroup(json.id, json.name);
	}
}
